<template>
  <div>
    <PageHeader title="ราคาชั่วโมงเรียนและวันเรียน" />
    <b-container fluid="xl">
      <div class="py-5 text-font">
        <div class="inner bg-container">
          <b-card class="no-shadow" no-body>
            <b-tabs card>
              <b-tab title="ชั่วโมงเรียน" active>
                <HourPriceTab />
              </b-tab>
              <b-tab title="วันเรียน">
                <DayPriceTab />
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import PageHeader from "@/components/layouts/PageHeader.vue";
import DayPriceTab from "./panel/DayPriceTab.vue";
import HourPriceTab from "./panel/HourPriceTab.vue";

export default {
  components: {
    PageHeader,
    DayPriceTab,
    HourPriceTab,
  },
};
</script>

<style scoped>
.text-font {
  font-family: "Sarabun", sans-serif;
}

.bg-container {
  background: #fff;
  border-radius: 8px;
}

.no-shadow {
  box-shadow: none !important;
}
</style>